import { TypographyTypes } from '../theme/typography';
import useThemeContext from './useThemeContext';

const useGetThemeComponentTypography = () => {
  const theme = useThemeContext();

  const getTypographyType = (type: TypographyTypes): Object => {
    if (!theme.typography[type]) {
      throw new Error(`Invalid typography type: ${type}!`);
    }
    return theme.typography[type];
  };

  return getTypographyType;
};

export default useGetThemeComponentTypography;
